// Light, dark, or as the device says: the stored choice, shared by both apps.
// Applying it is each app's (the web sets a data attribute, native picks a palette).

export type ThemeChoice = "system" | "light" | "dark";

export const THEME_KEY = "aybuben:theme";
export const THEMES: readonly ThemeChoice[] = ["system", "light", "dark"];

export function parseTheme(raw: string | null): ThemeChoice {
	return raw === "light" || raw === "dark" ? raw : "system";
}

/** Degrades to the device's theme when storage is blocked (private mode, site data off). */
export function loadTheme(): ThemeChoice {
	try {
		return parseTheme(globalThis.localStorage?.getItem(THEME_KEY) ?? null);
	} catch {
		return "system";
	}
}

export function storeTheme(choice: ThemeChoice): void {
	try {
		if (choice === "system") globalThis.localStorage?.removeItem(THEME_KEY);
		else globalThis.localStorage?.setItem(THEME_KEY, choice);
	} catch {
		/* remembered for this session only */
	}
}
